export default __webpack_public_path__ + "static/media/25.a9750f6a.jpg";